import { SearchFilter } from '@aibees/elephant/feature/search-filters';
import { UseBoolean } from '@aibees/shared/hooks';
import { Breakpoint } from '@mui/material';

export interface JobTitleExpanderProps extends SearchFilter {
  className?: string;
  submitTitle?: string;
  uncontrolledElement?: false | JSX.Element;
  disabled?: boolean;
  defaultOpen?: boolean;
  state?: UseBoolean;
  onOpen?: VoidFunction;
  onClose?: VoidFunction;
  defaultValues?: string[];
  onClickUncontrolledElement?: VoidFunction;
  size?: Breakpoint | false;
  value?: string;
  onClear?: (valueToRemove?: string) => void;
  onSubmit?: (data: string[]) => void;
}
export interface AddJobRoleExpanderRequest {
  titles: string[];
  combine?: boolean;
}

export type TitlesWithCategories = {
  titles: {
    [key: string]: string[];
  };
};

export type TitlesCombined = {
  titles: {
    combined: string[];
  };
};

export type AddJobRoleExpanderResponse = TitlesWithCategories | TitlesCombined;

export enum JobTitleCategoryToggleButtonType {
  ByCategories = 'by_categories',
  AllTitles = 'all_titles',
}
